import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "datatables.net";
import "datatables.net-bs5";
import "datatables.net-select-dt";
import "datatables.net-responsive-dt";
import "../../Destination/custom.css"; // Assuming custom styles

const DiscountModes = () => {
  const tableRef = useRef(null); // Ref for DataTable
  const [showForm, setShowForm] = useState(false); // Show/hide left form box
  const [selectedDiscountMode, setSelectedDiscountMode] = useState(null); // Selected for edit
  const [discountModes, setDiscountModes] = useState([
    { discountMode: "Percentage", status: "Active", id: 1 },
    { discountMode: "Fixed Value", status: "Inactive", id: 2 },
  ]);

  const [formData, setFormData] = useState({
    discountMode: "",
    status: "Active",
  });

  useEffect(() => {
    if (tableRef.current) {
      // Destroy existing table before re-init to avoid errors
      if ($.fn.dataTable.isDataTable(tableRef.current)) {
        $(tableRef.current).DataTable().destroy();
      }
      $(tableRef.current).DataTable({
        responsive: true,
        paging: true,
        searching: true,
        info: true,
      });
    }
  }, [discountModes]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (selectedDiscountMode) {
      setDiscountModes(
        discountModes.map((d) =>
          d.id === selectedDiscountMode.id ? { ...formData, id: d.id } : d
        )
      );
    } else {
      setDiscountModes([
        ...discountModes,
        { ...formData, id: discountModes.length ? discountModes[discountModes.length - 1].id + 1 : 1 },
      ]);
    }
    setShowForm(false);
    setFormData({ discountMode: "", status: "Active" });
    setSelectedDiscountMode(null);
  };

  const handleEdit = (discountMode) => {
    setSelectedDiscountMode(discountMode);
    setFormData({
      discountMode: discountMode.discountMode,
      status: discountMode.status,
    });
    setShowForm(true);
  };

  const handleAddClick = () => {
    setSelectedDiscountMode(null);
    setFormData({ discountMode: "", status: "Active" });
    setShowForm(true);
  };

  return (
    <div className="discount-mode-list d-flex" style={{ gap: "1rem", padding: "1rem" }}>
      {/* Left side form box */}
      {showForm && (
        <div
          className="form-box card"
          style={{
            width: "300px",
            padding: "1rem",
            border: "1px solid #ddd",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
          }}
        >
          <h2>{selectedDiscountMode ? "Edit Discount Mode" : "Add Discount Mode"}</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label>Discount Mode:</label>
              <input
                type="text"
                name="discountMode"
                value={formData.discountMode}
                onChange={handleChange}
                required
                className="form-control"
                placeholder="e.g. Percentage or Fixed Value"
              />
            </div>
            <div className="mb-3">
              <label>Status:</label>
              <select
                name="status"
                value={formData.status}
                onChange={handleChange}
                className="form-control"
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>
            <button type="submit" className="btn btn-success me-2">
              Save
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() => setShowForm(false)}
            >
              Cancel
            </button>
          </form>
        </div>
      )}

      {/* Right side table box */}
      <div className="table-container flex-grow-1">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h1>Discount Modes</h1>
            <button className="btn btn-md btn-primary" onClick={handleAddClick}>
              Add Discount Mode
            </button>
          </div>
          <div className="card-body">
            <table
              ref={tableRef}
              className="table table-bordered display"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>Discount Mode</th>
                  <th>Status</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {discountModes.map((discountMode) => (
                  <tr key={discountMode.id}>
                    <td>{discountMode.discountMode}</td>
                    <td>
                      <span
                        className={`badge ${
                          discountMode.status === "Active" ? "bg-success" : "bg-danger"
                        }`}
                      >
                        {discountMode.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-warning btn-sm"
                        onClick={() => handleEdit(discountMode)}
                      >
                        Edit
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DiscountModes;
